<mat-progress-bar
  *ngIf="(userDataSource.loading$ | async) || (passKeyDataSource.loading$ | async) || isLoading()"
  mode="indeterminate"
></mat-progress-bar>
<div class="flex flex-col gap-4">
  <h2 i18n>Two-Factor Authentication</h2>
  <mat-slide-toggle
    [disabled]="isLoading()"
    [ngModel]="userData()?.twoFactorEnabled"
    (ngModelChange)="toggleTwoFactor($event)"
  >
    <span class="ml-2 text-lg font-semibold" i18n>Enable Two-Factor Authentication</span>
    <p class="!ml-2 text-sm text-gray-400" i18n>Add an extra layer of security to your account by enabling two-factor authentication.</p>
  </mat-slide-toggle>

  <mat-divider></mat-divider>

  <h2 i18n>Passkey Authentication</h2>
  <div class="flex flex-row gap-4">
    <button
      (click)="requestPasskey()"
      [disabled]="passKeyData()?.isActive"
      class="w-fit"
      color="primary"
      mat-raised-button
      i18n
    >Request new passkey</button>
    <button
      (click)="deletePasskeyRequest()"
      [disabled]="!passKeyData()?.isActive"
      class="w-fit"
      color="warn"
      mat-raised-button
      i18n
    >Delete current passkey request</button>
  </div>
  <mat-list>
    @for (passkey of passKeyData()?.credentials; track passkey.id) {
      <mat-list-item>
        <mat-icon matListItemIcon>key</mat-icon>
        <div matListItemTitle>
            <span>
              <ng-container i18n>Label</ng-container>: <b>{{ passkey.userLabel }}</b>
            </span>
          <button eurogardConfirm (confirmed)="deletePassKey(passkey.id)" color="warn" mat-icon-button type="button">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="!mt-1" matListItemLine><ng-container i18n>Created at</ng-container>: <b>{{ passkey.createdDate | dateWithTimeAgo : true }}</b></div>
      </mat-list-item>
    }
  </mat-list>
</div>
